import {createApp} from 'vue';
import {mediaSearchController} from '@sftype/media-search-controller'
import {OutputComponent} from '@sftype/media-search-controller'
import {LoaderComponent} from '@sftype/media-search-controller'
import {CaptchaComponent} from '@sftype/media-search-controller'
import {ErrorComponent} from '@sftype/media-search-controller'

const app = createApp({
  components: {
    LoaderComponent,
    OutputComponent,
    CaptchaComponent,
    ErrorComponent,
  },
  data() {
    return this.$mediaSearchController.vueAppComponentData;
  },
  methods: {
    async handleSearchButtonClick() {
      await this.$mediaSearchController.onSearchButtonClick(this);
    },
    async handleSuccessSubmitCaptcha() {
      this.$mediaSearchController.hideCaptcha(this);
      await this.handleSearchButtonClick();
    },
    handleHideCaptcha() {
      this.$mediaSearchController.hideCaptcha(this);
    },
    handleInputChange(event) {
      this.$mediaSearchController.onInputChange(this, event);
    },
    handleInputPaste() {
      window.setTimeout(() => {
        this.handleSearchButtonClick()
      }, 100)
    },
    handleTooManyRequests() {
      this.$mediaSearchController.showCaptcha(this);
    },
  }
})
app.use(mediaSearchController, {
  searchInputSelector : '.form__form-input',
  searchButtonSelector : '.form__form-button',
  apiConvertDomain: 'api.ssstwit.com',
  subscribeSignedRequestBody: async (url) => {
    let getSignedRequestBody;

    try {
      getSignedRequestBody = await (
        await import(
          /* webpackChunkName: "link.chunk" */
          './tools/getSignedRequestBody.js'
          )
      ).default
    } catch {
      getSignedRequestBody = async (url) => {
        return {url}
      }
    }

    return await getSignedRequestBody(url)
  },
  services: ['twitter'],
})
app.mount('#app');
